import {
  SET_PAGE_SIZE,
  SET_SEARCH_QUERY,
  SET_CONFIGURED_POS_VISIBLE,
  SET_CONFIGURED_BOARDS_VISIBLE,
  SET_CONFIGURED_PRINTERS_VISIBLE,
  SET_CURRENT_PAGINATION_PAGE,
  UPDATE_OFFSET,
} from './actionTypes'

export const initialState = {
  pageSize: '10',
  searchQuery: '',
  isConfiguredPOSVisible: true,
  isConfiguredBoardsVisible: false,
  isConfiguredPrintersVisible: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PAGE_SIZE: {
      return {
        ...state,
        pageSize: payload,
      }
    }

    case UPDATE_OFFSET: {
      return {
        ...state,
        offset: payload,
      }
    }

    case SET_CURRENT_PAGINATION_PAGE: {
      const { screen, page } = payload

      return {
        ...state,
        screenPaginationPage: {
          [screen]: { page },
        },
      }
    }

    case SET_SEARCH_QUERY: {
      return {
        ...state,
        searchQuery: payload,
      }
    }

    case SET_CONFIGURED_POS_VISIBLE: {
      return {
        ...state,
        isConfiguredPOSVisible: payload,
      }
    }

    case SET_CONFIGURED_BOARDS_VISIBLE: {
      return {
        ...state,
        isConfiguredBoardsVisible: payload,
      }
    }

    case SET_CONFIGURED_PRINTERS_VISIBLE: {
      return {
        ...state,
        isConfiguredPrintersVisible: payload,
      }
    }

    default:
      return state
  }
}
